module.exports = __webpack_public_path__ + "img/visa.21befafd.svg";